module.exports = __webpack_public_path__ + "static/media/student record mangement.652d33d5.svg";